import React from 'react';
import { APP_LOGO_URL } from '../constants/branding';

export default function BrandLogo({ className = '', size = 40, alt = 'NextFollowUp' }) {
  return (
    <img
      src={APP_LOGO_URL}
      alt={alt}
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain', display: 'block' }}
    />
  );
}
